var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"content error404"},[_c('h1',[_vm._v("Page not found (404)")]),_c('p',[_vm._v("I can't find the page you're looking for.")]),_c('p',[_c('b-link',{attrs:{"to":"/"}},[_vm._v("Back to the homepage")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }